import baseURL from '../url';

export const fetchProducts = async () => {
  const response = await fetch(`${baseURL}/productosGet.php`);
  const data = await response.json();
  console.log(data);  // Esto te mostrará la estructura de los datos en la consola

  return data.productos;
};
